import $ from 'jquery';

$('.promos-img-url').each(function () {
  const url = $(this).data('img');
  const model = $(this).data('model');
  let image = new Image();

  image.onload = function (obj) {
    $(`.promo-${model}`).removeClass('hidden').find('img').removeClass('hidden');
    $('.promos-scene').remove();
  };

  image.onerror = function () {
    $(`.promo-${model}`).remove();
  };

  image.src = url;
});

// $('.promos-img-url-mobile').each(function () {

//   const url = $(this).data('img');
//   const model = $(this).data('model');
//   let image = new Image();

//   image.src = url;
//   console.log(image);

// });
